import React from "react";

//components
import { Grid, TextField, Tooltip, Divider } from "@material-ui/core";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import Autocomplete from "@material-ui/lab/Autocomplete";

//icons
import { AiOutlinePlusSquare } from "react-icons/ai";
import { GrEdit } from "react-icons/gr";
import { MdDeleteForever } from "react-icons/md";

// style
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  newButton: {
    cursor: "pointer",
  },
  optionRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  optionTitle: { fontSize: 12 },
  optionButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "20%",
  },
}));

function DropDown({ options, selected, label }) {
  const classes = useStyle();

  return (
    <Grid container direction="row">
      <Grid item xs={11}>
        <Autocomplete
          options={options}
          classes={{
            option: classes.option,
          }}
          size="small"
          autoHighlight
          getOptionLabel={(option) => option.title}
          renderOption={(option) => (
            <>
              {
                <div className={classes.optionRow}>
                  <div className={classes.optionTitle}>
                    {option.title + " "}
                  </div>
                  <div className={classes.optionButtonsContainer}>
                    <Tooltip title="Delete Item">
                      <span>
                        <MdDeleteForever />
                      </span>
                    </Tooltip>

                    <Tooltip title="Edit Item">
                      <span>
                        <GrEdit />
                      </span>
                    </Tooltip>
                  </div>
                </div>
              }
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-password", // disable autocomplete and autofill
              }}
            />
          )}
        />
      </Grid>
      <Tooltip title="New Item" className={classes.newButton}>
        <Grid item container justify="center" alignItems="center" xs={1}>
          <AiOutlinePlusSquare size="1.5rem" />
        </Grid>
      </Tooltip>
    </Grid>
  );
}

export default DropDown;
